// TODO: ALE: refatorar, ver simple-modal (talvez de para usar ele, ver arquivo modal360.blade.php e product-models360.js)

function initialize() {
    document.querySelectorAll('.trigger-modal-video').forEach(function (element) {
        element.addEventListener('click', function () {
            const videoId = element.getAttribute('data-video');
            document.querySelector('.modal-video').classList.remove('invisible');
            document.querySelector('.modal-video').classList.remove('-z-modal');
            document.querySelector('.modal-video').classList.remove('opacity-0');
            document.querySelector('.modal-video-content').classList.remove('-z-modal-content');

            document.querySelector('.modal-video').classList.add('z-modal');
            document.querySelector('.modal-video').classList.add('opacity-1');
            document.querySelector('.modal-video-content').classList.add('z-modal-content');

            document
                .querySelector('.modal-video-content iframe')
                .setAttribute('src', `https://www.youtube.com/embed/${videoId}?rel=0`);
        });
    });

    document.querySelector('.close-modal').addEventListener('click', function () {
        document.querySelector('.modal-video').classList.add('invisible');
        document.querySelector('.modal-video').classList.add('-z-modal');
        document.querySelector('.modal-video').classList.add('opacity-0');
        document.querySelector('.modal-video-content').classList.add('-z-modal-content');

        document.querySelector('.modal-video').classList.remove('z-modal');
        document.querySelector('.modal-video').classList.remove('opacity-1');
        document.querySelector('.modal-video-content').classList.remove('z-modal-content');

        document.querySelector('.modal-video-content iframe').setAttribute('src', '');
    });
}

initialize();
